module.exports = __webpack_public_path__ + "fonts/LatoLatin-Light.c425d3f.woff2";